import { Button as AntButton, type ButtonProps } from 'antd-v5';

import '../scss/_button.scss';

const Button = AntButton;

Button.defaultProps = {
  shape: 'round',
  type: 'primary',
};

export type { ButtonProps };

export default Button;
